
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/ups",
      function () {
        return require("private-next-pages/partners/ups.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/ups"])
      });
    }
  